<span>
  <button (click)="click()" [disabled]="disabled"
          mat-button matTooltip="Kundensonderpreis bearbeiten">
    <svg-icon
      color="{{disabled ? 'grey' : 'orange'}}">
      sonderpreis
    </svg-icon>
  </button>
</span>
